import { Injectable } from '@angular/core';
import { Consorcio } from '../model/Consorcio';
import { UtilitiesService } from '../services/utilities.service';

import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';




@Injectable()
export class ConsorciosService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService
  ) { }

  getConsorcios() : Observable<Consorcio[]> {
         
    let json = {   "Metodo": "getConsorcio",   "Datos":  {}};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  } 

  getConsorciosUsuario(query:any) : Observable<Consorcio[]> {

    let json = {   "Metodo": "getConsorcioUsuario",   "Datos": query};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  } 

 public insert(consorcio: Consorcio){
   
    let json = {   "Metodo": "postConsorcio",   "Datos": consorcio  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}


public delete(consorcio: Consorcio){
  
    let json = {   "Metodo": "deleteConsorcio",   "Datos": consorcio  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());

}

}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/consorcios.service.ts